import React, { useRef, useCallback } from 'react';
import FeedbackIcon from '@atlaskit/icon/core/migration/feedback';
import {
	EntryKeys,
	ENTRYPOINT_ID_JIRA_PLATFORM,
} from '@atlassian/jira-feedback-collector/src/constants.tsx';
import { useFeedbackCollectorActions } from '@atlassian/jira-feedback-collector/src/controllers/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { FEEDBACK_GROUP_ID } from '../../../constants.tsx';
import { messages } from './messages.tsx';

export const GiveFeedbackItem = () => {
	const { formatMessage } = useIntl();
	const { openFeedbackCollector } = useFeedbackCollectorActions();
	const feedbackButtonRef = useRef<HTMLButtonElement>(null);
	const onSubmitFeedbackClick = useCallback(() => {
		openFeedbackCollector({
			feedbackGroupId: FEEDBACK_GROUP_ID,
			entrypointId: ENTRYPOINT_ID_JIRA_PLATFORM,
			additionalFields: [
				{
					id: EntryKeys.JSM_QUEUES_SIDE_BAR,
					value: 'true',
				},
			],
			triggerRef: feedbackButtonRef,
		});
	}, [openFeedbackCollector, feedbackButtonRef]);

	return (
		<MenuItem
			analytics={{ itemId: 'feedback' }}
			iconBefore={<FeedbackIcon spacing="spacious" label="" />}
			onClick={onSubmitFeedbackClick}
			ref={feedbackButtonRef}
		>
			{formatMessage(messages.giveFeedback)}
		</MenuItem>
	);
};
